import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME as name, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		PovinostPzn: [],
	},
	edit: {
		XPovinostPzn: null as string | null,
		XEditPracId: null as string | null,
		ZaznamId: null as number | null,
		TableId: null as number | null,
		TableName: null as string | null,
		XObjektName: null as string | null,
		XColumnName: null as string | null,
		PovinostMaxFlags: null as number | null,
		PovinostPzn: null as number | null,
		ColumnName: null as string | null,
		EditPracId: null as number | null,
		EditDat: null as Date | null,
	},
	depTableNames: [],
	depTableSettings: {},
	localState: {},
	extraActions: {},
	extraGetters: {},
	extraMutations: {},
	props: {
		mode: null,
	},
});
